import { getDefaultConfig, WalletList } from "@rainbow-me/rainbowkit"
import {
    coinbaseWallet,
    coreWallet,
    injectedWallet,
    metaMaskWallet,
    okxWallet,
    rabbyWallet,
    safeWallet,
    trustWallet,
    walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets"
import once from "lodash/once"
import { defineChain, http } from "viem"
import { arbitrum, avalanche, fraxtalTestnet as _fraxtalTestnet, fraxtal } from "viem/chains"

import binanceWallet from "./connecters/binanceW3W/binanceWallet"

const WALLET_CONNECT_PROJECT_ID = "de24cddbaf2a68f027eae30d9bb5df58"

const popularWalletList: WalletList = [
    {
        // Group name with standard name is localized by rainbow kit
        groupName: "Popular",
        wallets: [
            rabbyWallet,
            metaMaskWallet,
            walletConnectWallet,
            // This wallet will automatically hide itself from the list when the fallback is not necessary or if there is no injected wallet available.
            injectedWallet,
            // The Safe option will only appear in the Safe Wallet browser environment.
            safeWallet,
        ],
    },
]

const othersWalletList: WalletList = [
    {
        groupName: "Others",
        wallets: [binanceWallet, coinbaseWallet, trustWallet, coreWallet, okxWallet],
    },
]

export const mantleTestnet = defineChain({
    id: 5003,
    name: "Mantle Testnet",
    nativeCurrency: {
        decimals: 18,
        name: "MNT",
        symbol: "MNT",
    },
    rpcUrls: {
        default: { http: ["https://rpc.sepolia.mantle.xyz"] },
    },
    blockExplorers: {
        default: {
            name: "Mantle Testnet Explorer",
            url: "https://explorer.sepolia.mantle.xyz",
            apiUrl: "https://explorer.sepolia.mantle.xyz/api",
        },
    },
    testnet: true,
})

const sourceId = 17000 // holesky
const fraxtalTestnet = /*#__PURE__*/ defineChain({
    id: 2522,
    name: "Fraxtal Testnet",
    nativeCurrency: { name: "Frax Ether", symbol: "frxETH", decimals: 18 },
    rpcUrls: {
        default: {
            http: ["https://rpc.testnet.frax.com"],
        },
    },
    blockExplorers: {
        default: {
            name: "fraxscan testnet",
            url: "https://holesky.fraxscan.com",
            apiUrl: "https://api-holesky.fraxscan.com/api",
        },
    },
    contracts: {
        l2OutputOracle: {
            [sourceId]: {
                address: "0x715EA64DA13F4d0831ece4Ad3E8c1aa013167F32",
            },
        },
        multicall3: {
            address: "0x34215E99eaBB2F37f1dEc17f65220CB20F578939",
        },
        multicall: {
            address: "0x34215E99eaBB2F37f1dEc17f65220CB20F578939",
        },
        portal: {
            [sourceId]: {
                address: "0xB9c64BfA498d5b9a8398Ed6f46eb76d90dE5505d",
                blockCreated: 318416,
            },
        },
        l1StandardBridge: {
            [sourceId]: {
                address: "0x0BaafC217162f64930909aD9f2B27125121d6332",
                blockCreated: 318416,
            },
        },
    },
    sourceId,
})

export const getRainbowKitConfig = once(() =>
    getDefaultConfig({
        appName: "Calabi",
        projectId: WALLET_CONNECT_PROJECT_ID,
        chains: [arbitrum, avalanche, fraxtal, fraxtalTestnet, mantleTestnet],
        transports: {
            [arbitrum.id]: http(),
            // [avalanche.id]: http(),
            [fraxtal.id]: http(),
            [fraxtalTestnet.id]: http(),
            [mantleTestnet.id]: http(),
        },
        wallets: [...popularWalletList, ...othersWalletList],
    }),
)
